class BuyNow extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.cartUrl = this.getAttribute('data-cart-url');
    this.variantId = this.getAttribute('data-variant-id');
    this.quantity = 1;

    if (!this.cartUrl || !this.variantId) {
      console.warn('buy-now: data-cart-url or data-variant-id missing');
      return;
    }

    this.button.addEventListener('click', this.handleClick.bind(this));
    document.body.addEventListener('quantity-change', this.handleQuantityChange.bind(this));
    document.body.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
  }

  /**
   * Handles 'click' events on the quantity input element.
   * @param {object} evt - Event object.
   */
  handleClick(evt) {
    evt.preventDefault();

    window.location.href = `${this.cartUrl}/${this.variantId}:${this.quantity}`;
  }

  /**
   * Handles 'quantity-change' events on the document.
   * @param {object} evt - Event object.
   */
  handleQuantityChange(evt) {
    this.quantity = evt.detail.quantity;
  }

  /**
   * Handles 'on:variant:change' events on the document.
   * @param {object} evt - Event object.
   */
  handleVariantChange(evt) {
    const variant = evt.detail.variant;

    this.variantId = variant.id;

    this.button.disabled = !variant.available;
  }
}

customElements.define('buy-now', BuyNow);
